module.exports = __webpack_public_path__ + "static/media/Wild For_eCommerce.4e9a789e.png";